import React from "react";
import { Button, ImageWithFallback } from "../components/Utilities";
import dummyImg from "../assets/dummyImg.svg";
// import leftArrow from "../assets/leftslide.svg";
import rightArrow from "../assets/rightslide.svg";
import { useNavigate } from "react-router-dom";
import imgTop from "../assets/imgTop.png";
import imgBottom from "../assets/imgBottom.png";
import locCard from "../assets/locCard.svg";
import rc_yes from "../assets/rc-yes.svg";
import rc_no from "../assets/rc-no.svg";
import dummy_top from "../assets/dummy_top.svg";
import dummy_footer from "../assets/dummy_footer.svg";
import logo from "../assets/trustauto-logo.png";
import { LiveTimer } from "../components/CardLayout";
import dummyBody from "../assets/dummybody.svg";
import Delete from "../assets/Delete.svg";

// Car Card Component
export const CarCard = ({
  car,
  onCarSelect,
  onRemove,
  onSlideRight,
  onSlideLeft,
  isFourth,
  hasMoreCars,
  index, // Pass the index from the parent component
}) => {
   const navigate = useNavigate();
  
  // Debug: Log car data to see isSold field
  console.log('CarCard - Car data:', {
    id: car.id,
    isSold: car.isSold,
    isSoldType: typeof car.isSold,
    isSoldTruthy: !!car.isSold
  });
  
  return (
    <div
      className={`car-card ${car.isDummy ? "dummy" : ""} ${car.isSold ? "sold" : ""}`}
      onClick={() => onCarSelect(car)}
    >
      {/* SOLD Overlay */}
      {car.isSold && (
        <div className="sold-overlay">
          <div className="sold-badge">
            <span className="sold-text">SOLD</span>
          </div>
        </div>
      )}
      
      {!car.isDummy ? (
        <>
          <div className="car-image-wrapper">
            <img src={imgTop} className="imgTop" alt="" />
            <img src={imgBottom} className="imgBottom" alt="" />
            <ImageWithFallback
              src={car.isDummy ? dummyImg : car.image}
              alt={car.isDummy ? "Dummy Car" : `${car.brand} ${car.model}`}
              className="car-image"
            />
            <LiveTimer startDateStr={car.startDate} endDateStr={car.endDate} />
            <div className="car-location">
              <ImageWithFallback src={locCard} alt="Location" />
              <p className="car-location-name">{car.location}</p>
            </div>
          </div>

          <div className="car-details">
            <div className="car-info">
              <h3 className="car-title">
                {car.year} {car.brand} {car.model}
              </h3>
              <div className="car-spec-container">
                <div className="car-specs">
                  <span className="distance">
                    {car.rc ? (
                      <img src={rc_yes} alt="" className="rc" />
                    ) : (
                      <img src={rc_no} alt="" className="rc" />
                    )}
                    {car.km.toLocaleString()} kms
                  </span>
                  <span className="car-fuel">
                    {" • "}
                    {car.fuel} • {car.transmission}
                  </span>
                </div>
                <div className="car-tags">
                  {car.rc ? (
                    <img src={rc_yes} alt="" className="rc" />
                  ) : (
                    <img src={rc_no} alt="" className="rc" />
                  )}
                  <span className="rto-tag">{car.rto}</span>
                  <span className="owner-tag">{car.owner}</span>
                </div>
                <div className="phone-car-location">
                              <ImageWithFallback src={locCard} alt="Location" />
                              <p className="car-location-name">{car.location}</p>
                            </div>
              </div>
                 <img src={Delete} alt="" className="phoneBin" onClick={(e) => {
                  e.stopPropagation();
                  onRemove(car.id);
                }} />
            </div>

            <div className="car-actions">
              <Button
                className="btn-full"
                variant="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(car.id);
                }}
              >
                Remove
              </Button>
            </div>
          </div>
        </>
      ) : (
        <div className={`dummy-layout ${index % 2 === 1 ? "dummy-layout-alt" : ""}`}>
          <div className="dummy-header">
            <img src={dummy_top} alt="" className="dummyTop" />
            <img src={logo} alt="" className="dummyLogo" />
          </div>
          <div className="dummy-body">
            <div className={`dummy_words ${index % 2 === 1 ? "dummy_words-alt" : ""}`}>
              <p>INDIA’S LEADING B2B USED CAR MARKETPLACE</p>
            </div>
            <Button
              onClick={() => {navigate("www.trustauto.in")}}
              className={`dummy-button ${index % 2 === 1 ? "dummy-button-alt" : ""}`}
            >
              Know More
            </Button>
          </div>
          <div className="dummy-footer">
            <img src={dummy_footer} alt="" className="dummyBottom" />
          </div>
        </div>
      )}
      {isFourth && hasMoreCars && (
        <>
          <button
            className="left-slide-button"
            onClick={(e) => {
              e.stopPropagation();
              onSlideLeft(car.yard || "Unknown Yard");
            }}
          >
            <img src={rightArrow} alt="Slide Left" className="left-slide-icon" />
          </button>
          <button
            className="right-slide-button"
            onClick={(e) => {
              e.stopPropagation();
              onSlideRight(car.yard || "Unknown Yard");
            }}
          >
            <img
              src={rightArrow}
              alt="Slide Right"
              className="right-slide-icon"
            />
          </button>
        </>
      )}
    </div>
  );
};
